import { CollapsableGroup } from '@/module/AnnualReport/components/CollapsableGroup';
import { AnnualReportTechnologicalTransfers } from '@/module/AnnualReport/model/AnnualReportTypes';
import { TechnologicalTransferValidationAction } from '@/module/Author/TechnologicalTransfer/Validation/TechnologicalTransferValidationAction';
import { TechnologicalTransferCard } from '@/module/Author/TechnologicalTransfer/components/Card/TechnologicalTransferCard';

interface AnnualTechnologicalTransfersOverviewProps {
  technologicalTransfers: AnnualReportTechnologicalTransfers;
}

export function AnnualTechnologicalTransfersOverview({
  technologicalTransfers: { technologicalTransfers },
}: AnnualTechnologicalTransfersOverviewProps) {
  return (
    <CollapsableGroup
      title="Transferuri tehnologice care aparțin universității"
      items={technologicalTransfers}
      renderValidation={technologicalTransfer => (
        <TechnologicalTransferValidationAction
          variant="compact"
          technologicalTransferId={technologicalTransfer.id}
        />
      )}
      renderItem={technologicalTransfer => (
        <TechnologicalTransferCard
          technologicalTransfer={technologicalTransfer}
          onClick={() => window.open(`/author/technological-transfer/${technologicalTransfer.id}`)}
        />
      )}
    />
  );
}
